
import { singularityStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";
import SingularityCanvasButton from "./SingularityCanvasButton.vue";

import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    SingularityCanvasButton
  }
})
export default class AddSectionButton extends Vue {
  @Prop()
  sectionId!: TreeNode["id"];

  addSection() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add_after",
      sectionId: this.sectionId
    });
    singularityStore.setSectionLibraryModalState(true);
  }
}
